let imageIds = {};

export const addRequestImages = (images) => {
  for (let i = 0; i < images.length; i++) {
    let image = images[i];

    if (!imageIds[image]) {
      imageIds[image] = { count: 0, cancelFn: () => {} };
    }

    imageIds[image].count += 1;
  }

  // console.log('*** addRequestImages:', imageIds);
};

export const removeRequestImages = (images) => {
  for (let i = 0; i < images.length; i++) {
    let image = images[i];

    if (imageIds[image]) {
      imageIds[image].count -= 1;
    }

    if (imageIds[image].count === 0) {
      imageIds[image].cancelFn();
      delete imageIds[image];
    }
  }

  // console.log('*** removeRequestImages:', imageIds);
};

export const addCancelRequest = (image, cancelFn) => {
  // console.log('*** addCancelRequest:', image);
  if (!imageIds[image]) {
    imageIds[image] = { count: 0, cancelFn };
  } else {
    imageIds[image].cancelFn = cancelFn;
  }
};

export const removeCancelRequest = (image) => {
  // console.log('*** removeCancelRequest:', image);
  if (imageIds[image]) {
    imageIds[image].cancelFn = () => {};
  }
};
